/* tslint:disable */
/* tslint:disable */
/**
 * ClearFlask Admin API
 * ClearFlask API documentation.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/* tslint:disable */
// eslint-disable-next-line no-unused-vars
import { exists } from '../runtime';
/**
 * 
 * @export
 * @interface ProjectOwnerSwapSuperAdmin
 */
export interface ProjectOwnerSwapSuperAdmin {
    /**
     * 
     * @type {string}
     * @memberof ProjectOwnerSwapSuperAdmin
     */
    projectId?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectOwnerSwapSuperAdmin
     */
    newOwnerAccountId?: string;
}

export function ProjectOwnerSwapSuperAdminFromJSON(json: any): ProjectOwnerSwapSuperAdmin {
    return {
        'projectId': !exists(json, 'projectId') ? undefined : json['projectId'],
        'newOwnerAccountId': !exists(json, 'newOwnerAccountId') ? undefined : json['newOwnerAccountId'],
    };
}

export function ProjectOwnerSwapSuperAdminToJSON(value?: ProjectOwnerSwapSuperAdmin): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        'projectId': value.projectId,
        'newOwnerAccountId': value.newOwnerAccountId,
    };
}


